import {
    FETCH_ACTIVE_POPUP_REQUEST,
    FETCH_CREATE_NEW_POPUP_REQUEST,
    FETCH_POPUP_FAILURE,
    FETCH_POPUP_REQUEST,
    FETCH_POPUP_SUCCESS,
    FETCH_PUBLISH_POPUP_REQUEST
} from './actionTypes'
import {TodoActions, TodoState} from './types'
const initialState: TodoState = {
    pending: false,
    popUp: [],
    totalPage: 0,
    error: null,
    popupInfo: {}
};

const toPopupReducer = (state = initialState, action: TodoActions) => {
    switch (action.type) {
            case FETCH_POPUP_REQUEST:
                return {
                    ...state,
                    pending: true
                }
            case FETCH_POPUP_SUCCESS:
                return {
                    ...state,
                    pending: false,
                    popUp: action.payload.popUp,
                    popupInfo: action.payload.popupInfo,
                    error: null
                }
            case FETCH_POPUP_FAILURE:
                return {
                    ...state,
                    pending: false,
                    error: action.payload
                }
            case FETCH_ACTIVE_POPUP_REQUEST:
                return {
                    ...state,
                    pending: true
                }
            case FETCH_PUBLISH_POPUP_REQUEST:
                return {
                    ...state,
                    pending: true
                }
            case FETCH_CREATE_NEW_POPUP_REQUEST:
                return {
                    ...state,
                    pending: true
                }
        default:
            return {
                ...state,
            };
    }
}
export default toPopupReducer